DOMReady( function(){
  [... document.querySelectorAll('.btn-print')].map( btnprint => {
    btnprint.addEventListener('click', function(e){
      e.preventDefault();
      let src = this.href;
      let zone = '<img loading="lazy" src="'+src+'"/>';
      let fen = window.open("", "", "height=500, width=800,menubar=0,status=0");
      // style du popup
      fen.document.body.style.color = '#000000';
      fen.document.body.style.backgroundColor = '#FFFFFF';
      fen.document.body.style.padding = "10px";
      // Ajout des données a imprimer
      fen.document.title = title;
      fen.document.body.innerHTML += " " + zone + " ";
      setTimeout(function () { fen.window.print(); }, 500);
      fen.window.onfocus = function () { setTimeout(function () { fen.window.close(); }, 500); }
      return false;
    });
  });
});
